export default __webpack_public_path__ + "static/media/hardware@2x.69ed9c43.webp";